import React from 'react';

import { useNFTsFiltersStore } from '@app/store/zustand/profile-page/useNFTsFiltersStore.ts';

import { FilterChip } from '../FilterChips/FilterChip';

import { ClearAction, ClearActionLabel, ResultsText, Wrapper } from './FilterChips.style';

export interface FilterChipsProps {
    filteredResultCount?: number;
}

export function FilterChips({ filteredResultCount = 0 }: FilterChipsProps) {
    const { currentFilters, resetFilters } = useNFTsFiltersStore();
    const selectedTotal = currentFilters.total;

    // TODO: We should not be early returning here.
    // This will break the components entrance/exit animation.
    if (selectedTotal === 0) return null;

    const parsedFilters = currentFilters.parse as Record<string, string[]>;
    const selectedFilters = Object.keys(parsedFilters).filter((key) => parsedFilters[key]?.length);
    const chipMarkup = selectedFilters?.map((filter) => <FilterChip key={filter} text={filter} />);

    // TODO: This component should animate in/out.
    return (
        <Wrapper>
            <ResultsText>{`${filteredResultCount} Results`}</ResultsText>

            {chipMarkup}

            <ClearAction onAction={resetFilters}>
                <ClearActionLabel>Clear all</ClearActionLabel>
            </ClearAction>
        </Wrapper>
    );
}
